export default "__VITE_ASSET__eac49021__"